import apiClient from '@/lib/api-client';

/** API counts remain decimal text so the browser never loses BIGINT precision. */
export interface AnalyticsAggregate { route: string; role: 'admin' | 'manager' | 'employee' | 'customer'; day: string; count: string; }

export async function getPageViews(from: string, to: string): Promise<AnalyticsAggregate[]> {
  const response = await apiClient.get<{ data: AnalyticsAggregate[] }>('/analytics/pageviews', { params: { from, to } });
  return response.data.data;
}
